import { render } from "./CommentInList.vue?vue&type=template&id=568591ec&scoped=true"
import script from "./CommentInList.vue?vue&type=script&lang=js"
export * from "./CommentInList.vue?vue&type=script&lang=js"

import "./CommentInList.vue?vue&type=style&index=0&id=568591ec&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568591ec"]])

export default __exports__